import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=02acd4ab&"
import script from "./TableComponent.vue?vue&type=script&lang=js&"
export * from "./TableComponent.vue?vue&type=script&lang=js&"
import style0 from "./TableComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTh,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QTh,QTr,QTd}, component.options.components || {})
